import { Card, Space } from '@sravni/react-design-system';
import type { CardColor } from '@sravni/react-design-system/dist/types/components/Card/types/Card.types';
import { Heading, Text } from '@sravni/react-design-system/lib/Typography';
import cn from 'classnames';
import type { ReactNode } from 'react';

interface IOfferPopupFeature {
  label: string | ReactNode;
  value: string | number | ReactNode;
  className?: string;
  color?: CardColor;
}

export const OfferPopupFeature = ({ label, value, className, color = 'dark' }: IOfferPopupFeature) => (
  <Card
    color={color}
    size={16}
    className={cn('h-pt-18 h-pb-18', className)}
  >
    <Space
      size={8}
      direction="vertical"
    >
      <Text
        data-qa="OfferNote"
        className="h-color-D60"
      >
        {label}
      </Text>
      <Heading
        level={4}
        data-qa="OfferNote"
      >
        {value}
      </Heading>
    </Space>
  </Card>
);
